import { render, staticRenderFns } from "./UploadDocument.vue?vue&type=template&id=26e2b56b&"
import script from "./UploadDocument.vue?vue&type=script&lang=js&"
export * from "./UploadDocument.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocument.vue?vue&type=style&index=0&id=26e2b56b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports